<template>
  <section class="reportRatio">
    <template v-if="$store.getters.errorMessageWithReportRatioQuarter">
      <b-alert class="text-center" variant="primary" show dismissible>
        系統查找失效，請重新輸入搜尋代碼或稍待片刻
      </b-alert>
    </template>
    <template v-else>
      <sheet
        :sheetFields="$store.getters.fieldsOfLiquiditiesQuarter"
        :sheetData="$store.getters.layerOfLiquiditiesQuarter"
        :sheetName="'償債能力表_季'"
        :companyName="$store.getters.reportRatioQuarter[0].company_name"
        :stockID="$store.getters.reportRatioQuarter[0].stock_symbol"
        :unit="'%'"
      />
      <sheet
        :sheetFields="$store.getters.fieldsOfReturnOnInvestmentsQuarter"
        :sheetData="$store.getters.itemsOfReturnOnInvestmentsQuarter"
        :sheetName="'獲利能力表_季'"
        :companyName="$store.getters.reportRatioQuarter[0].company_name"
        :stockID="$store.getters.reportRatioQuarter[0].stock_symbol"
        :unit="'%'"
      />
      <sheet
        :sheetFields="$store.getters.fieldsOfPerShareRatiosQuarter"
        :sheetData="sortFieldsOfPerShareRatiosQuarter"
        :sheetName="'每股比例表_季'"
        :companyName="$store.getters.reportRatioQuarter[0].company_name"
        :stockID="$store.getters.reportRatioQuarter[0].stock_symbol"
        :unit="'元、%'"
        :isMultipleUnit="true"
      />
      <sheet
        :sheetFields="$store.getters.fieldsOfOperatingPerformancesQuarter"
        :sheetData="$store.getters.itemsOfOperatingPerformancesQuarter"
        :sheetName="'經營能表_季'"
        :companyName="$store.getters.reportRatioQuarter[0].company_name"
        :stockID="$store.getters.reportRatioQuarter[0].stock_symbol"
        :unit="'天'"
      />
    </template>
  </section>
</template>

<script>
import sheet from "@/components/sheet.vue";
export default {
  components: {
    sheet
  },
  computed: {
    sortFieldsOfPerShareRatiosQuarter() {
      const baseData = this.$store.getters.itemsOfPerShareRatiosQuarter.filter(
        item =>
          item.subTitle !== "近四季每股EPS" &&
          item.subTitle !== "每股盈餘－完全稀釋－EPS"
      );
      const itemEPS4Seasons = this.$store.getters.itemsOfPerShareRatiosQuarter.find(
        item => item.subTitle === "近四季每股EPS"
      );
      const itemEPS = this.$store.getters.itemsOfPerShareRatiosQuarter.find(
        item => item.subTitle === "每股盈餘－完全稀釋－EPS"
      );
      itemEPS.subTitle = "每股EPS";
      return [itemEPS4Seasons, itemEPS, ...baseData];
    }
  }
  // async created() {
  //   await Promise.all([
  //     // this.$store.dispatch("FETCH_LAYER"),
  //     this.$store.dispatch("FETCH_REPORT_RATIO_QUARTER")
  //   ]);
  // }
};
</script>

<style scoped lang="scss">
::v-deep caption {
  padding-bottom: 0;
}
::v-deep .table-hover tbody tr:hover {
  background-color: #343a40;
  color: #fff;
}
</style>
